import React from 'react';

import MuteButton from './MuteButton';


function FeaturedClipControls(props) {
  const { isFeaturedClip, isMuted, onMute, showMuteButton } = props;

  return (
    <div className="featured-controls">
      <MuteButton isFeaturedClip={isFeaturedClip} isMuted={isMuted} onMute={onMute} showMuteButton={showMuteButton} />
    </div>
  );
}

export default FeaturedClipControls;
